module.exports = __webpack_public_path__ + "media/bootstrap-icons/grid-3x2-f85b5f34.svg";